import Funnel from './funnel';
export default Funnel;